

































import { Component, Prop, InjectReactive, Vue } from 'vue-property-decorator'
import Auth from "../auth"
import Account from "../account"

@Component
export default class Navigation extends Vue {
    $log: any
    @InjectReactive() auths?: Auth[]
    @InjectReactive() account?: Account
    get avatar() {
        if (this.account && this.account.avatarUrl) {
            return this.account.avatarUrl
        } else {
            return '/assets/img/default_avatar.png'
        }
    }
}
